// extracted by mini-css-extract-plugin
module.exports = {"container":"article-module--container--B5goX"};